import React, { FC } from 'react';
import styled from 'styled-components';

import { Loader, SCEclipseLoader } from '~/atomic/atom/Loader';
import { PaperStyle } from '~/atomic/atom/PaperStyle';
import {
  identifyErrorSelector,
  identifyResultSelector,
  isIdentifyLoadingSelector,
} from '~/atomic/page/anti-pirate/check/antiPirate.selector';
import {
  SCTextReg, TextBoldStyle, TextRegStyle,
} from '~/atomic/Typography';
import { lessThan } from '~/lib/mediaQuery';
import { useAppSelector } from '~/store';

export const CheckResult: FC = () => {
  const isIdentifyLoading = useAppSelector(isIdentifyLoadingSelector);
  const identifyResult = useAppSelector(identifyResultSelector);
  const identifyError = useAppSelector(identifyErrorSelector);

  return (identifyResult || isIdentifyLoading) && (
    <SCResultBlock data-result={identifyResult}>
      {
        isIdentifyLoading && (
          <>
            <SCResultHeadWrapper>
              <SCResultTitle>
                Результат проверки
              </SCResultTitle>
              <SCLoaderWrapp>
                <Loader size={70} />
              </SCLoaderWrapp>
            </SCResultHeadWrapper>
            <SCTextReg>
              Идет проверка...
            </SCTextReg>
          </>
        )
      }
      {
        identifyResult && (
          <>
            <SCResultHeadWrapper>
              <SCResultTitle>
                Результат проверки
              </SCResultTitle>
              <SCResultIcon
                width={68}
                height={68}
                src={
                  identifyResult === 'success'
                    ? '/icon/green-lens.svg'
                    : '/icon/red-lens.svg'
                }
              />
            </SCResultHeadWrapper>
            <SCResultDescription>
              {
                identifyResult === 'success'
                  ? 'Копия произведения идентифицирована.\n'
                        + 'Действие аккаунта пользователя, допустившего '
                        + 'распространение приостановлено'
                  : identifyError
              }
            </SCResultDescription>
          </>

        )
      }
    </SCResultBlock>
  );
};

const SCResultHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${lessThan('md')} {
    flex-direction: row;
    margin-bottom: 8px;
  }
`;

const SCResultDescription = styled.span`
  ${TextRegStyle};
  text-align: center;
  color: var(--black-color);
`;

const SCResultIcon = styled.img`
  margin-bottom: 26px;
  
  ${lessThan('md')} {
    margin-left: 8px;
    width: 32px;
    height: 32px;
    margin-bottom: unset;
  }
`;

const SCLoaderWrapp = styled.div`
  position: relative;
  padding-bottom: 52px;
  margin-bottom: 52px;

  ${lessThan('md')} {
    padding-bottom: 32px;
    margin-bottom: unset;
    margin-left: 24px;
    
    ${SCEclipseLoader} {
      --size: 36px !important;
    }
  }
`;

const SCResultTitle = styled.span`
  ${TextBoldStyle};
  color: var(--black-color);
  margin-bottom: 28px;

  ${lessThan('md')} {
    margin-bottom: unset;
  }
`;

const SCResultBlock = styled.div`
  ${PaperStyle};
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 268px;
  max-width: 415px;
  width: 100%;
  margin-top: 81px;
  
  &[data-result="success"] {
    background-color: var(--green-color);
  }

  &[data-result="fail"] {
    background-color: #fef3f6;
  }

  ${lessThan('md')} {
    margin-top: 18px;
    padding: 12px;
    margin-bottom: 18px;
    height: unset;
    width: calc(100% - 32px);
    align-items: flex-start;
  }
`;
